import { render, staticRenderFns } from "./msgcode.vue?vue&type=template&id=462e0e09&scoped=true"
import script from "./msgcode.vue?vue&type=script&lang=js"
export * from "./msgcode.vue?vue&type=script&lang=js"
import style0 from "./msgcode.vue?vue&type=style&index=0&id=462e0e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e0e09",
  null
  
)

export default component.exports